export default {
  methods: {
      /**
       * @desc 调用指定名称的父级的方法
       * @param {String} componentName 组件名称name属性
       * @param {String} eventName 接收方的事件名
       * @param {Array} params 调用事件传的参数
       */
      dispatch(componentName, eventName, params = []) {
          let parent = this.$parent || this.$root;
          let name = parent.$options.name;

          while (parent && (!name || name !== componentName)) {
              parent = parent.$parent;

              if (parent) {
                  name = parent.$options.name;
              }
          }

          if (parent) {
              return parent.$emit.apply(parent, [eventName, ...params]);
          }
      },
  },
};
